import { Flex, Grid, useDisclosure, Icon } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { MonthlySelectorProps } from '../types';
import { Popover } from '@/components/ats';
import { ChevronDownIcon } from '@heroicons/react/solid';

export const MonthlySelector = ({
  selectedDayOfMonth,
  formatDayWithOrdinal,
  handleDateChange,
  modalContainerRef,
  formRef,
}: MonthlySelectorProps) => (
  <Flex gap="6px" flexDirection="column" mb="12px">
    <KText size="sm-medium" color="secondary-900">
      Day of the month
    </KText>

    <CustomDayPicker
      selectedDay={selectedDayOfMonth}
      onChange={handleDateChange}
      containerRef={modalContainerRef}
      formatDayWithOrdinal={formatDayWithOrdinal}
      formRef={formRef}
    />
  </Flex>
);

const CustomDayPicker = ({
  selectedDay,
  onChange,
  containerRef,
  formatDayWithOrdinal,
  formRef,
}) => {
  const popoverActions = useDisclosure();

  const handleDaySelect = (day) => {
    onChange(formatDayWithOrdinal(day));
    formRef.current.setFieldValue('deliver_day_of_month', day);
    popoverActions.onClose();
  };

  // Generate 31 days
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const triggerElement = (
    <Flex
      border="1px solid"
      borderColor="border-color"
      borderRadius="sm"
      p="10px 8px 10px 10px"
      alignItems="center"
      justifyContent="space-between"
      cursor="pointer"
      _hover={{ borderColor: 'secondary-100' }}
    >
      <KText>
        {selectedDay ? formatDayWithOrdinal(selectedDay) : 'Select day'}
      </KText>
      <Icon as={ChevronDownIcon} w="24px" h="24px" color="secondary-700" />
    </Flex>
  );

  const popoverContent = (
    <Grid templateColumns="repeat(7, 1fr)" gap={2} p={2} width="280px">
      {days.map((day) => (
        <Flex
          key={day}
          justify="center"
          align="center"
          p={2}
          borderRadius="full"
          bg={selectedDay === day ? 'primary-500' : 'transparent'}
          cursor="pointer"
          _hover={{
            bg: selectedDay === day ? 'primary-500' : 'primary-25',
          }}
          onClick={() => handleDaySelect(day)}
        >
          <KText
            size="xs-medium"
            color={selectedDay === day ? 'white' : 'secondary-700'}
          >
            {day}
          </KText>
        </Flex>
      ))}
    </Grid>
  );

  return (
    <Popover
      triggerElement={triggerElement}
      popoverActions={popoverActions}
      children={popoverContent}
      showArrow={false}
      showCloseButton={false}
      popoverProps={{
        placement: 'top-start',
      }}
    />
  );
};
